(function () {
  if (window.__aiInfiniteScrollLoaded) return;
  window.__aiInfiniteScrollLoaded = true;

  var state = {
    loading: false,
    observer: null
  };

  function initAiInfiniteScroll() {
    var grid = document.getElementById('product-grid');
    var trigger = document.querySelector('[data-ai-infinite-scroll]');
    if (!grid || !trigger) return;

    if (state.observer) {
      state.observer.disconnect();
    }

    var nextUrl = trigger.getAttribute('data-next-url');
    var pagination = document.querySelector('.pagination-wrapper');
    var status = document.querySelector('[data-ai-infinite-status]');

    if (!nextUrl) {
      if (pagination) pagination.hidden = true;
      if (status) status.textContent = '';
      return;
    }

    if (pagination) pagination.hidden = true;
    trigger.hidden = false;
    state.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadNextPage(grid, trigger, status);
        }
      });
    }, {
      rootMargin: '700px 0px'
    });
    state.observer.observe(trigger);
  }

  function loadNextPage(grid, trigger, status) {
    var nextUrl = trigger.getAttribute('data-next-url');
    if (!nextUrl || state.loading) return;

    state.loading = true;
    trigger.classList.add('is-loading');
    if (status) status.textContent = 'Weitere Artikel werden geladen...';

    fetch(nextUrl, {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Next page failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.getElementById('product-grid');
        var nextTrigger = doc.querySelector('[data-ai-infinite-scroll]');
        var items = nextGrid ? Array.prototype.slice.call(nextGrid.children) : [];

        items.forEach(function (item) {
          item.classList.add('ai-infinite-scroll__item');
          grid.appendChild(document.importNode(item, true));
        });

        var newNextUrl = nextTrigger ? nextTrigger.getAttribute('data-next-url') : '';
        trigger.setAttribute('data-next-url', newNextUrl || '');

        if (!newNextUrl) {
          trigger.hidden = true;
          if (state.observer) state.observer.disconnect();
          if (status) status.textContent = '';
        } else if (status) {
          status.textContent = '';
        }

        document.dispatchEvent(new CustomEvent('ai:infinite-scroll:loaded', {
          bubbles: true,
          detail: {
            itemCount: items.length,
            nextUrl: newNextUrl
          }
        }));
      })
      .catch(function () {
        var fallback = document.querySelector('.pagination-wrapper');
        if (fallback) fallback.hidden = false;
        if (status) status.textContent = 'Weitere Artikel konnten nicht automatisch geladen werden.';
        trigger.hidden = true;
        if (state.observer) state.observer.disconnect();
      })
      .finally(function () {
        state.loading = false;
        trigger.classList.remove('is-loading');

        // Re-arm the observer after a load. Without this, an intersection
        // that occurs while state.loading is true can be missed permanently.
        if (state.observer && !trigger.hidden && trigger.getAttribute('data-next-url')) {
          state.observer.unobserve(trigger);
          state.observer.observe(trigger);
        }
      });
  }

  document.addEventListener('DOMContentLoaded', initAiInfiniteScroll);
  document.addEventListener('shopify:section:load', initAiInfiniteScroll);
  document.addEventListener('ai:collection-grid:refresh', initAiInfiniteScroll);
})();
